/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPower = createReactComponent("outline", "power", "IconPower", [["path", { "d": "M7 6a7.75 7.75 0 1 0 10 0", "key": "svg-0" }], ["path", { "d": "M12 4l0 8", "key": "svg-1" }]]);

export { IconPower as default };
//# sourceMappingURL=IconPower.mjs.map
